import { request, errHandler } from "./heimdall";
import store from "../store";

export function getProjects() {
  return request
    .get(`/projects`, {
      headers: {
        Authorization: store.getters.getToken
      }
    })
    .then(({ data }) => data)
    .catch(errHandler);
}

export function getProject(id) {
  return request
    .get(`/projects/${id}`, {
      headers: {
        Authorization: store.getters.getToken
      }
    })
    .then(({ data }) => data)
    .catch(errHandler);
}

export function getUserInProject(id) {
  return request
    .get(`/projects/user/${id}`, {
      headers: {
        Authorization: store.getters.getToken
      }
    })
    .then(({ data }) => data)
    .catch(errHandler);
}

export function createProject(data) {
  return request
    .post("/projects/create", data, {
      headers: {
        Authorization: store.getters.getToken
      }
    })
    .then(({ data }) => data)
    .catch(errHandler);
}

export function updateProject(id, data) {
  return request
    .put(`/projects/update/${id}`, data, {
      headers: {
        Authorization: store.getters.getToken
      }
    })
    .then(({ data }) => data)
    .catch(errHandler);
}

export function deleteProject(id) {
  return request
    .delete(`/projects/delete/${id}`, {
      headers: {
        Authorization: store.getters.getToken
      }
    })
    .then(({ data }) => data)
    .catch(errHandler);
}

export function getStatus() {
  return request
    .get(`/status`, {
      headers: {
        Authorization: store.getters.getToken
      }
    })
    .then(({ data }) => data)
    .catch(errHandler);
}

export function getBenefits() {
  return request
    .get(`/benefits`, {
      headers: {
        Authorization: store.getters.getToken
      }
    })
    .then(({ data }) => data)
    .catch(errHandler);
}

export function getUsers() {
  return request
    .get(`/users`, {
      headers: {
        Authorization: store.getters.getToken
      }
    })
    .then(({ data }) => data)
    .catch(errHandler);
}

export function getTypes() {
  return request
    .get(`/types`, {
      headers: {
        Authorization: store.getters.getToken
      }
    })
    .then(({ data }) => data)
    .catch(errHandler);
}

export function addInvoice(number, amount, project_id) {
  return request
    .post(
      `/invoices/create/`, {
        number: number,
        amount: amount,
        project_id: project_id
      },
      {
        headers: { Authorization: store.getters.getToken }
      }
    )
    .then(({ data }) => data)
    .catch(errHandler);
}

export function updateInvoice(id, number, amount, project_id) {
  return request
    .put(
      `/invoices/update/${id}`,
      {
        id: id,
        number: number,
        amount: amount,
        project_id: project_id
      },
      {
        headers: { Authorization: store.getters.getToken }
      }
    )
    .then(({ data }) => data)
    .catch(errHandler);
}

export function removeInvoice(id) {
  return request
    .delete(`/invoices/delete/${id}`, {
      headers: { Authorization: store.getters.getToken }
    })
    .then(({ data }) => data)
    .catch(errHandler);
}